<template lang="pug">
  include /mixins
  label(
    v-bem.label='{"bound": true}'
    :class="[{'d-control-input__label--active': value }]"
    :for='id',
  ) {{ inputLabel }}
    slot
    span(
      v-if='isRequired'
      v-bem.is_required=''
    ) *
</template>

<script>

export default {
  name: 'BoundLabel',
  block: 'd-control-input',
  props: {
    labelText: {},
    id: {
      type: String,
      required: false,
    },
    value: {},
    inputLabel: {
      type: String,
    },
    isRequired: {
      type: Boolean,
    },
  },
}
</script>
